module.exports = __webpack_public_path__ + "static/media/document.7dcc469e.png";